module.exports = __webpack_public_path__ + "static/media/Sempione - Sand - Black_White.798589bb.jpg";